export default __webpack_public_path__ + "static/media/a019.1851f939.gif";